import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import {
  DateCalendar,
  type DateCalendarProps,
} from '@mui/x-date-pickers/DateCalendar';
import {
  PickersDay,
  type PickersDayProps,
} from '@mui/x-date-pickers/PickersDay';
import { setDefaultOptions } from 'date-fns';
import { useWeekStartsOnPreference } from '@witmetrics/data-store';
import { parseDate } from '@witmetrics/utils/time';
import { getDayClassName, getDayStyling, styles } from './utils';

export type DateRangeCalendarProps = {
  disablePast?: boolean;
  activeDate: string;
  start: string;
  end: string;
  onChange: DateCalendarProps<any>['onChange'];
};

export default function DateRangeCalendar({
  disablePast,
  activeDate,
  start,
  end,
  onChange,
}: DateRangeCalendarProps) {
  const weekStartsOn = useWeekStartsOnPreference();

  setDefaultOptions({ weekStartsOn });

  const renderDay = (props: PickersDayProps<Date>) => {
    return (
      <PickersDay
        {...props}
        sx={getDayStyling(props.day, start, end)}
        className={getDayClassName(props.className, props.day, start, end)}
      />
    );
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DateCalendar
        showDaysOutsideCurrentMonth
        disablePast={disablePast}
        sx={styles.calendar}
        value={parseDate(activeDate)}
        slots={{
          day: (props) => renderDay(props),
        }}
        onChange={onChange}
      />
    </LocalizationProvider>
  );
}
